import { PropsWithChildren } from 'react';
import { Scrollbar } from '@components';
import styles from './PagedDialog.module.scss';

type TProps = {
	width?: string;
}

export const Preview = (props: PropsWithChildren<TProps>) => {
	const { width = '30%', children } = props;
	return (
		<div className={styles.preview} style={{ width }}>
			<Scrollbar />
			{children}
		</div>
	);
}
Preview.displayName = 'Preview';
